class ProductPrice extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.compare_price = this.querySelector(".product-price--compare")),
        (this.percentage_off = this.querySelector(".product-price--percentage-off")),
            (this.price = this.querySelector(".product-price--original")),
            (this.reference_unit = this.querySelector(".product-price--reference-unit")),
            (this.reference_value = this.querySelector(".product-price--reference-value")),
            (this.unit_price = this.querySelector(".product-price--unit-price")),
            (this.unit_price_container = this.querySelector(".product-price--unit-container")),
            (this.is_bundle = this.dataset.bundle),
            (this.discount = this.dataset.discount),
            (this.is_gwp = this.dataset.gwp || false),
            this.updatePriceListener();
    }
    disconnectedCallback() {
        window.off(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`);
    }
    updatePriceListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged.ProductPrice`, ({ detail: { variant: e } }) => {
            if (this.is_bundle == 'false') {
                this.updatePrices(e);   
            }
        });
    }
    updatePrices(e) {
        if (e) {            
            this.removeAttribute("style");
            if (this.is_gwp) {
                this.price.innerHTML = 'FREE'
            } else {
                this.price.innerHTML = theme.utils.formatMoney(e.price);
            }
        
            if (e.compare_at_price > e.price) {
                this.compare_price.innerHTML = theme.utils.formatMoney(e.compare_at_price);
                this.compare_price.style.display = "inline-block";

                var price_diff = e.compare_at_price - e.price;
                var percent_diff = (price_diff * 100) / e.compare_at_price;
                var sale_text = Math.floor(percent_diff) + '% OFF';
                if (this.discount) {
                    var stringWithoutPercentage = this.discount.replace('%', '');
                    var diff = stringWithoutPercentage - percent_diff;
                    if (diff < 3) {
                        var sale_text = this.discount + ' OFF';
                    }
                    ;
                }
                this.price.classList.add('price-label--sale');
                if (this.percentage_off) {
                    this.percentage_off.innerHTML = sale_text;   
                }
            } else {
                this.compare_price.style.display = "none";
                this.price.classList.remove('price-label--sale');
                if (this.percentage_off) {
                    this.percentage_off.innerHTML = "";
                }
            }
        
            if (e.unit_price_measurement) {
                this.unit_price.innerHTML = theme.utils.formatMoney(e.unit_price);
                this.reference_unit.innerHTML = e.unit_price_measurement.reference_unit;
        
                if (e.unit_price_measurement.reference_value === 1 && this.reference_value) {
                    this.reference_value.style.display = "none";
                } else if (this.reference_value) {
                    this.reference_value.innerHTML = e.unit_price_measurement.reference_value;
                    this.reference_value.style.display = "block";
                }
        
                this.unit_price_container.style.display = "flex";
            } else {
                this.unit_price_container.style.display = "none";
            }
        } else {
            this.style.display = "none";
        }
    }
}
const productPriceEl = customElements.get("product-price-root");
productPriceEl || customElements.define("product-price-root", ProductPrice);
